"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gridHeaderCell = void 0;
const react_1 = __importDefault(require("react"));
const GridHeaderCell_1 = require("./components/GridHeaderCell/GridHeaderCell");
function gridHeaderCell(config) {
    return function HeaderCellRenderer({ ref, column, cellIndex, className, handlers = {} }) {
        var _a, _b;
        return (react_1.default.createElement(GridHeaderCell_1.GridHeaderCell, Object.assign({ "data-selector-id": "grid-core-header-cell", containerRef: ref, title: config.title, content: (_b = (_a = config.content) === null || _a === void 0 ? void 0 : _a.call(config, column)) !== null && _b !== void 0 ? _b : null, justify: column.justify, columnWidth: column.width, hasBigLeftIntent: column.hasBigLeftIntent, columnId: column.id, key: `header-cell-${cellIndex}-${column.id}`, sorting: config.sorting, tooltipMaxWidth: config.tooltipMaxWidth ? `${config.tooltipMaxWidth}px` : '', onClick: config.onClick, clickable: config.clickable, highlighted: config.highlighted }, handlers, { className: className })));
    };
}
exports.gridHeaderCell = gridHeaderCell;
//# sourceMappingURL=gridHeaderCellRenderer.js.map